import Layout from 'components/Layout';
import NotFound from 'components/NotFound';
import ServerError from 'components/ServerError';
import { NextPageContext } from 'next';
import { useTranslation } from 'react-i18next';
import { ReactNode } from 'react';
import { captureException } from '@sentry/nextjs';

interface Props {
  statusCode?: number;
}

export default function Error({ statusCode }: Props): JSX.Element {
  const { t } = useTranslation();

  function errorComponent(): ReactNode {
    switch (statusCode) {
      case 404:
        return <NotFound />;
      case 500:
        return <ServerError />;
      default:
        // Fill this in later
        return undefined;
    }
  }

  return (
    <div data-testid="error-page-component">
      <Layout
        title={t(`main.meta.pageTitle`)}
        description={t(`main.meta.metaDescription`)}
        indexed={false}
      >
        {errorComponent()}
      </Layout>
    </div>
  );
}

Error.getInitialProps = ({ res, err }: NextPageContext): Props => {
  // capture server-side exceptions that are automatically handled by nextjs
  // see https://github.com/getsentry/sentry-javascript/issues/3869
  if (err) {
    captureException(err);
  }

  const statusCode = res?.statusCode || err?.statusCode || 404;
  return { statusCode };
};
